import ManageUpLoadContent from "../components/Admin/Users/uploadContents/ManageUpLoadContents";
import ManageActivities from "../components/Admin/Activities/ManageActivity";
import ManageCategories from "../components/Admin/Categories/ManageCategory";
import ManageInterests from "../components/Admin/Interests/ManageInterests";
import ManageInstructor from "../components/Admin/Instructors/ManageInstructor";
import ManageAdminDashBoard from "../components/Admin/AdminDashBoard/ManageAdminDashBoard";
import ManageAdminVerifiedContent from "../components/Admin/AdminVerifiedContent/ManageAdminVerifiedContents";
import ManageEventAttendees from "../components/Admin/Events/EventsAttendees/ManageEventAttendees";
import ManageUserPublication from "../components/Admin/Users/publishedContents/ManageUserPublishedContents";
import ManageUserDraft from "../components/Admin/Users/draftContents/ManageUserDraftContents";
import ManageEvent from "../components/Admin/Events/ManageEvent";
import ViewSpecificContent from "../components/Admin/Users/publishedContents/ViewSpecificContents";
import AdminViewSpecificContent from "../components/Admin/AdminDashBoard/ApprovePublishContent";
import ManageBanners from "../components/Admin/BANNERAD/ManageBanner";
import ManageMerchants from "../components/Admin/Merchants/ManageMerchants";
import ManageDealCategories from "../components/Admin/DealsCategory/ManageDealCategories";
import ManageDeals from "../components/Admin/Deals/ManageDeals";
import ManageFoodLibrary from "../components/Admin/FoodLibrary/ManageFoodLibrary";
import ManageMealPlan from "../components/Admin/MealPlan/ManagedMealPlan";

import ManagePublishedMealPlanTable from "../components/Admin/Users/publishedMealPlans/ManagePublishedMealPlanTable";
import ManageDraftMealPlanTable from "../components/Admin/Users/draftMealPlans/ManageDraftMealPlanTable";
import ViewSpecificMealPLan from "../components/Admin/Users/publishedMealPlans/viewSpecificPublishedMealPlans";
import ManageAllMealPlans from "../components/Admin/Users/manageMealPlans/ManageAllMealPlans";
import ManagePendingMealPlanTable from "../components/Admin/AdminPublishedMealPlans/ManagePendingMealPlanTable";
import AdminViewSpecificMealPLan from "../components/Admin/AdminPublishedMealPlans/ViewSpecificMealPLan";
import EditMealPlanManager from "../components/Admin/Users/draftMealPlans/EditMealPlanManager";
import InstructorManagedFoodLibrary from "../components/Admin/FoodLibrary/InstructorManagedFoodLibrary";
import ManageMealConfigs from "../components/MealConfigurations/ManagedMealConfigs";
export const routeConstants = {
    Setting: {
        CATEGORY: {
            key: "category",
            title: "Categories",
            exact: true,
            name: "AdminCreateCategories",
            path: "/admincreatecategories",
            menu: true,
            pageComponent: ManageCategories,
            enabled: true,
        },
        INTEREST: {
            key: "interest",
            title: "Interests",
            exact: true,
            name: "CreateInterest",
            path: "/interests",
            menu: true,
            pageComponent: ManageInterests,
            enabled: true,
        },

        ACTIVITY: {
            key: "activity",
            title: "Activities",
            exact: true,
            name: "CreateActivity",
            path: "/activities",
            menu: true,
            pageComponent: ManageActivities,
            enabled: true,
        },

        INSTRUCTOR: {
            key: "instructor",
            title: "Instructors",
            exact: true,
            name: "CreateInstructor",
            path: "/instructors",
            menu: true,
            pageComponent: ManageInstructor,
            enabled: true,
        },
    },

    Events: {
        EVENT: {
            key: "event",
            title: "Events",
            exact: true,
            name: "CreateEvents",
            path: "/events",
            menu: true,
            pageComponent: ManageEvent,
            enabled: true,
        },
    },
    Banners: {
        BANNER: {
            key: "bannerad",
            title: "Banner Ads",
            exact: true,
            name: "CreateBanners",
            path: "/banners",
            menu: true,
            pageComponent: ManageBanners,
            enabled: true,
        },
    },

    Deals: {
        MANAGEDEALS: {
            key: "deal",
            title: "Deals",
            exact: true,
            name: "Deals",
            path: "/deals",
            menu: true,
            pageComponent: ManageDeals,
            enabled: true,
        },
        DEALSCATEGORY: {
            key: "deals-category",
            title: "Categories",
            exact: true,
            name: "DealsCategories",
            path: "/deals-categories",
            menu: true,
            pageComponent: ManageDealCategories,
            enabled: true,
        },
    },

    Merchants: {
        MANAGEMERCHANTS: {
            key: "merchants",
            title: "Merchants",
            exact: true,
            name: "Merchants",
            path: "/merchants",
            menu: true,
            pageComponent: ManageMerchants,
            enabled: true,
        },
    },

    AdminDashBoard: {
        ADMINDASHBOARD: {
            key: "admindashboard",
            title: "Dashboard",
            exact: true,
            name: "AdminDashboard",
            path: "/dashboard",
            menu: true,
            pageComponent: ManageAdminDashBoard,
            enabled: true,
        },
    },
    AdminVerifiedContents: {
        VERIFIEDCONTENTS: {
            key: "verifiedcontents",
            title: "Contents",
            exact: true,
            name: "VerifiedContents",
            path: "/verifiedcontents",
            menu: true,
            pageComponent: ManageAdminVerifiedContent,
            enabled: true,
        },
    },

    AdminApprovedContents: {
        VERIFIEDCONTENTS: {
            key: "approvedcontents",
            title: "Content",
            exact: true,
            name: "Contents",
            path: "/approvedcontents",
            menu: true,
            pageComponent: AdminViewSpecificContent,
            enabled: true,
        },
    },
    AdminViewEventsAttendees: {
        VERIFIEDCONTENTS: {
            key: "eventsattendees",
            title: "Event Attendees",
            exact: true,
            name: "Event Attendees",
            path: "/eventsattendees",
            menu: true,
            pageComponent: ManageEventAttendees,
            enabled: true,
        },
    },
    UserDashBoard: {
        USERPUBLISHEDCONTENT: {
            key: "userpublishedcontent",
            title: "Published Contents",
            exact: true,
            name: "PublishedContents",
            path: "/dashboard",
            menu: true,
            pageComponent: ManageUserPublication,
            enabled: true,
        },
    },
    UserDrafts: {
        DRAFTS: {
            key: "drafts",
            title: "Drafts",
            exact: true,
            name: "UserDraft",
            path: "/userdrafts",
            menu: true,
            pageComponent: ManageUserDraft,
            enabled: true,
        },
    },
    UserUploadContents: {
        UPLOADCONTENTS: {
            key: "uploadcontents",
            title: "Upload Contents",
            exact: true,
            name: "UploadContents",
            path: "/useruploadcontents",
            menu: true,
            pageComponent: ManageUpLoadContent,
            enabled: true,
        },
    },
    UserSpecificContents: {
        UserSPECIFICContents: {
            key: "userspecificcontents",
            title: "Contents",
            exact: true,
            name: "userspecificcontents",
            path: "/userspecificcontents",
            menu: true,
            pageComponent: ViewSpecificContent,
            enabled: true,
        },
    },
    FoodLibrary: {
        ADMINVIEWPENDINGMEALPLANS: {
            key: "pendingmealsplans",
            title: "Meal Plan",
            exact: true,
            name: "ADMINVIEWPENDINGMEALPLANS",
            path: "/admin-pending-meal-plans",
            menu: true,
            pageComponent: ManagePendingMealPlanTable,
            enabled: true,
        },
        FOODLIBRARY: {
            key: "foodlibrary",
            title: "Food Item Library",
            exact: true,
            name: "FoodLibrary",
            path: "/food-library",
            menu: true,
            pageComponent: ManageFoodLibrary,
            enabled: true,
        },

        MEALPLANSCONFIGS: {
            key: "mealplansconfigs",
            title: "Meal Plan Setting",
            exact: true,
            name: "MEALPLANSCONFIGS",
            path: "/config-meal-plans",
            menu: true,
            pageComponent: ManageMealConfigs,
            enabled: true,
        },
        ADMINSPECIFICPENDINGMEALPLAN: {
            key: "specificpendingmealsplans",
            title: "Meal Plan",
            exact: true,
            name: "ADMINSPECIFICPENDINGMEALPLAN",
            path: "/admin-view-meal-plans",
            menu: false,
            pageComponent: AdminViewSpecificMealPLan,
            enabled: true,
        },
    },
    MealPlan: {
        MANAGEMEALS: {
            key: "managemeals",
            title: "Meal Plan",
            exact: true,
            name: "MANAGEMEALS",
            path: "/managed-meal-plans",
            menu: true,
            pageComponent: ManageAllMealPlans,
            enabled: true,
        },
        MEALPLAN: {
            key: "mealplan",
            title: "Create Meal Plan",
            exact: true,
            name: "MealPlan",
            path: "/meal-plan",
            menu: false,
            pageComponent: ManageMealPlan,
            enabled: true,
        },
        DRAFTMEALPLAN: {
            key: "draftmealplan",
            title: "Draft Meal Plans",
            exact: true,
            name: "DRAFTMEALPLAN",
            path: "/meal-plan-drafts",
            menu: false,
            pageComponent: ManageDraftMealPlanTable,
            enabled: true,
        },

        PUBLISHMEALPLAN: {
            key: "publishmealplan",
            title: "Published Meal Plans",
            exact: true,
            name: "PUBLISHMEALPLAN",
            path: "/meal-plan-publish",
            menu: false,
            pageComponent: ManagePublishedMealPlanTable,
            enabled: true,
        },
        FOODLIBRARY: {
            key: "foodlibrary",
            title: "Food Item Library",
            exact: true,
            name: "FoodLibrary",
            path: "/food-library",
            menu: true,
            pageComponent: InstructorManagedFoodLibrary,
            enabled: true,
        },
        VIEWSPECIFICMEALPLAN: {
            key: "mealspecificcontents",
            title: "Meal Plans Contents",
            exact: true,
            name: "VIEWSPECIFICMEALPLAN",
            path: "/meal-plan-view",
            menu: false,
            pageComponent: ViewSpecificMealPLan,
            enabled: true,
        },
        EDITPECIFICMEALPLAN: {
            key: "editmealplanspecificcontents",
            title: "Update Meal Plans Contents",
            exact: true,
            name: "EDITPECIFICMEALPLAN",
            path: "/edit-meal-plan",
            menu: false,
            pageComponent: EditMealPlanManager,
            enabled: true,
        },
    },
};
//approvedcontents
export const adminDashBoard = () => {
    const routes = [];
    for (var route in routeConstants.AdminDashBoard) {
        routeConstants.AdminDashBoard[route].enabled && routes.push(routeConstants.AdminDashBoard[route]);
    }
    return routes;
};

export const adminVerifiedContent = () => {
    const routes = [];
    for (var route in routeConstants.AdminVerifiedContents) {
        routeConstants.AdminVerifiedContents[route].enabled && routes.push(routeConstants.AdminVerifiedContents[route]);
    }
    return routes;
};
export const adminAprovedContent = () => {
    const routes = [];
    for (var route in routeConstants.AdminApprovedContents) {
        routeConstants.AdminApprovedContents[route].enabled && routes.push(routeConstants.AdminApprovedContents[route]);
    }
    return routes;
};

export const userUploadContent = () => {
    const routes = [];
    for (var route in routeConstants.UserUploadContents) {
        routeConstants.UserUploadContents[route].enabled && routes.push(routeConstants.UserUploadContents[route]);
    }
    return routes;
};

export const userDashBoardRoutes = () => {
    const routes = [];
    for (var route in routeConstants.UserDashBoard) {
        routeConstants.UserDashBoard[route].enabled && routes.push(routeConstants.UserDashBoard[route]);
    }
    return routes;
};

export const userDraftRoutes = () => {
    const routes = [];
    for (var route in routeConstants.UserDrafts) {
        routeConstants.UserDrafts[route].enabled && routes.push(routeConstants.UserDrafts[route]);
    }
    return routes;
};

export const userViewSpecificContentRoutes = () => {
    const routes = [];
    for (var route in routeConstants.UserSpecificContents) {
        routeConstants.UserSpecificContents[route].enabled && routes.push(routeConstants.UserSpecificContents[route]);
    }
    return routes;
};

export const createRoutes = () => {
    const routes = [];
    for (var route in routeConstants.Setting) {
        routeConstants.Setting[route].enabled && routes.push(routeConstants.Setting[route]);
    }
    return routes;
};

export const merchantRoutes = () => {
    const routes = [];
    for (var route in routeConstants.Merchants) {
        routeConstants.Merchants[route].enabled && routes.push(routeConstants.Merchants[route]);
    }
    return routes;
};

export const dealsRoutes = () => {
    const routes = [];
    for (var route in routeConstants.Deals) {
        routeConstants.Deals[route].enabled && routes.push(routeConstants.Deals[route]);
    }
    return routes;
};

export const eventAttendeeRoutes = () => {
    const routes = [];
    for (var route in routeConstants.AdminViewEventsAttendees) {
        routeConstants.AdminViewEventsAttendees[route].enabled && routes.push(routeConstants.AdminViewEventsAttendees[route]);
    }
    return routes;
};

export const eventsRoutes = () => {
    const routes = [];
    for (var route in routeConstants.Events) {
        routeConstants.Events[route].enabled && routes.push(routeConstants.Events[route]);
    }
    return routes;
};

export const bannerRoutes = () => {
    const routes = [];
    for (var route in routeConstants.Banners) {
        routeConstants.Banners[route].enabled && routes.push(routeConstants.Banners[route]);
    }
    return routes;
};

export const foodLibraryRoutes = () => {
    const routes = [];
    for (var route in routeConstants.FoodLibrary) {
        routeConstants.FoodLibrary[route].enabled && routes.push(routeConstants.FoodLibrary[route]);
    }
    return routes;
};

export const mealPlanRoutes = () => {
    const routes = [];
    for (var route in routeConstants.MealPlan) {
        routeConstants.MealPlan[route].enabled && routes.push(routeConstants.MealPlan[route]);
    }
    return routes;
};

export const userViewSpecificContent = userViewSpecificContentRoutes();
export const routes = createRoutes();
export const merchantRoute = merchantRoutes();
export const dealRoute = dealsRoutes();
export const usersdashBoard = userDashBoardRoutes();
export const userdrafts = userDraftRoutes();
export const useruploadContents = userUploadContent();
export const admindashBoard = adminDashBoard();
export const adminverifiedContents = adminVerifiedContent();
export const adminAprovedPost = adminAprovedContent();
export const adminViewEventsAttendee = eventAttendeeRoutes();
export const adminEventCreationRoute = eventsRoutes();
export const adminBannerRoute = bannerRoutes();
export const foodLibraryRoute = foodLibraryRoutes();
export const mealPlanRoute = mealPlanRoutes();
export const allRoutes = [
    ...routes,
    ...merchantRoute,
    ...dealRoute,
    ...usersdashBoard,
    ...userdrafts,
    ...useruploadContents,
    ...admindashBoard,
    ...adminverifiedContents,
    ...adminAprovedPost,
    ...userViewSpecificContent,
    ...adminViewEventsAttendee,
    ...adminEventCreationRoute,
    ...adminBannerRoute,
    ...foodLibraryRoute,
    ...mealPlanRoute,
];
